import angular from 'angular';
import { RSScheduleSalesComponent } from './rs-schedule-sales.component';
import { EditRSScheduleComponent } from './edit-rs-schedule.component';
import { ListRSSchedulesContainerComponent } from './list-rs-schedules-container.component';

/**
 * A module that defines event schedules with Road Shows-specific logic, such
 * as NCR data that pulls over from the payout site.
 */
export const RoadShowsScheduleModule = angular
    .module("apex.mainApp.eventsScheduling.roadShows", [])
    .component("apexRsScheduleSales", RSScheduleSalesComponent)
    .component("apexRsSchedule", EditRSScheduleComponent)
    .component("apexListRsschedulesContainer", ListRSSchedulesContainerComponent)
    .name
